import React, { FC, useState } from 'react';
import { BoothTab } from 'models/cms/boothTabs';

const TabsContext = React.createContext<{
  activeTabKey: number;
  setActiveTabKey: React.Dispatch<React.SetStateAction<number>>;
  tabs: Array<BoothTab>;
}>({
  activeTabKey: 0,
  setActiveTabKey: () => null,
  tabs: [],
});

const TabsContextStateProvider: FC<{ tabs?: Array<BoothTab> }> = ({
  children,
  tabs = [],
}) => {
  const [activeTabKey, setActiveTabKey] = useState<number>(0);

  return (
    <TabsContext.Provider
      value={{
        activeTabKey,
        setActiveTabKey,
        tabs,
      }}
    >
      {children}
    </TabsContext.Provider>
  );
};

export {
  TabsContextStateProvider,
  TabsContext,
};
